import 'whatwg-fetch';
import config from '../../config';

export const loadAnnotations = (token, client, documentid) => {
  return fetch(`${config.lambdaUrl}/annotations/${client}/${documentid}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin'
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const saveAnnotations = (token, client, documentid, annotationJSON) => {
  return fetch(`${config.lambdaUrl}/annotations/${client}/${documentid}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      JWT: token
    },
    credentials: 'same-origin',
    body: JSON.stringify({
      annotationJSON
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const loadPresets = (token, sessionid, client) => {
  return fetch(
    `${config.lambdaUrl}/sessionpreferences/${sessionid}/${client}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        JWT: token
      },
      credentials: 'same-origin'
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const savePresets = (token, sessionid, presetJson, client) => {
  return fetch(
    `${config.lambdaUrl}/sessionpreferences/${sessionid}/${client}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        JWT: token
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        presetJson
      })
    }
  )
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject('failed');
      }
      return response.json();
    })
    .catch(() => {
      return Promise.reject('failed');
    });
};

export const retrieveExportData = () => {
  return fetch('/exportData.json')
    .then(response => {
      return response.json();
    })
    .then(json => {
      console.log(json);
      return json;
    });
};
